<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ziuitq/tc-custom/9780825463976.jpg?1688985128908" alt="This image is the cover for the book 90 Days to Stress-Free"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">90 Days to Stress-Free
      </h1>
      <p class="bookDescription body article font2">
        <b>Encourages women on a day-by-day journey to find their way back to peace</b><br/><br/>Too often, women feel like their only hope for reducing stress is to push through and pray to make it to the other side. Well-intended projects to help the family, events to support the community, and ministries for church swirl into a cluttered, chaotic schedule. Yet worry is eating them alive from within.<br/><br/>Being stressed isn't the abundant life Christ wants for his people. Artist and author Jami Amerine knows the heaviness of expectations--both internal and external. And she has discovered how to retrain the mind against the framework worry lays down. In easily digestible daily readings, she shares what she's learned and offers the right tools for the job.<br/><br/>Through her witty, friendly words, vibrant original art, and rock-solid scriptural truth, Jami invites readers to join her on a journey to declutter the mind and uncover a spirit freshly renovated into a truly worry-free existence.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jami Amerine
      </h2>
      
      <p class="authorDescription body article"><b>Jami Amerine</b> is a best-selling author, artist, and mom living in Hawaii. Her art can be found at Home Goods, T. J. Maxx, and Etsy. Jami's previous books include <i>Stolen Jesus</i>, <i>Sacred Ground</i>, <i>Sticky Floors</i>, and <i>Well, Girl</i>. Connect with her at jamiamerine. com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Kregel Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14ade192